









import {Vue, Component, Prop, Emit, Model, Watch, Inject} from 'vue-property-decorator';

@Component({
  name: 'MySelect.vue',
  mounted() {
    if(this.propVal) {
      this.selfShow = this.options[this.propVal];
    }
    this.$nextTick(() => {
      document.querySelector('body').addEventListener('click', (e) => {
        if (Array.from(e.target.classList).includes('select')) {
          return;
        }
        this.$refs.selectWrapper.classList.add('select-hide');
      })
    })
  },
  destroyed() {
    document.querySelector('body').removeEventListener('click', (e) => {
      console.log(e.target.classList);
      if (Array.from(e.target.classList).includes('select')) {
        return;
      }
      this.$refs.selectWrapper.classList.add('select-hide');
    })
  }
})
export default class MyInput extends Vue {
  @Prop() placeholder: string;
  @Prop() disabled: boolean;
  @Prop() options: selectType;

  @Model('change')
  propVal: string

  selfShow: string = '';

  get selfVal(): string {
    return this.propVal
  };
  set selfVal(newValue) {
  }
  showSelectWrapper() {
    this.$refs.selectWrapper.classList.remove('select-hide');
  }
  selectOption(item, index) {
    this.selfShow = item;
    this.$refs.selectWrapper.classList.add('select-hide');
    this.emitChange(index);
  }
  closeOption() {
    this.$refs.selectWrapper.classList.add('select-hide');
  }

  @Emit('change')
  emitChange(newValue): void {

  }
}
